import React from 'react';
import FeatureCard from '@app/components/anonymize-pro-landing/components/cards/feature-card';
import { featureContent } from '@app/components/anonymize-pro-landing/mock/contents';

export default function FeatureMain() {
    return (
        <div className="w-full">
            {featureContent.map((feature) => (
                <FeatureCard key={feature.step} feature={feature} />
            ))}
        </div>
    );
}
